import { faUserShield } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

function PrivacyCC() {
  return (
    <div className='mt-2'>
        <div className='jumbotron text-center bg-light border'>
            <FontAwesomeIcon icon={faUserShield} fontSize={128} className='mb-5 text-danger' />
            <h2>Privacy Policy(Currency Converter)</h2>
            <p>Your privacy is our priority - we've got you covered!</p>
        </div>
        <div className='container'>
          <div className='card bg-light p-3'>
            <div className='card-body'>
                <p>Currency Converter ("App") is developed and published by Milesoft ("Developer"). This privacy policy ("Policy") explains how the App collects and uses information.</p>
                <h6>Information We Collect</h6>
                <p>The App collects ephemeral data consisting of currency codes and amounts to perform currency conversions. This ephemeral data is temporary and is not stored on our servers or on your device.</p>
                <h6>How We Use Information</h6>
                <p>We use ephemeral data solely to perform currency conversions and provide a better user experience. We do not use this data for any other purposes.</p>
                <h6>How We Disclose Information</h6>
                <p>We do not disclose any information to third-party service providers or other entities.</p>
                <h6>Security</h6>
                <p>We take reasonable measures to protect information from unauthorized access, use, and disclosure. However, no security measures are perfect, and we cannot guarantee the security of your information.</p>
                <h6>Children's Privacy</h6>
                <p>The App is not intended for use by children under the age of 13, and we do not knowingly collect personal information from children under the age of 13.</p>
                <h6>Changes to this Policy</h6>
                <p>We may update this Policy from time to time by posting the revised Policy on the App. We encourage you to review this Policy periodically for any changes.</p>
                <h6>Contact Us</h6>
                <p>If you have any questions or concerns about this Policy, please contact us at milesoft.co@gmail.com.</p>
                <p>By using the App, you consent to the collection and use of ephemeral data in accordance with this Policy.</p>
            </div>
          </div>
        </div>
        <div className='container'>&nbsp;</div>
    </div>
  )
}

export default PrivacyCC